const projects = [
    {
    title: "Archipelago Tracker",
    version: "main",
    image: "https://storage.ficsit.app/file/smr-prod-s3/images/mods/9mg7TSpp5gB6jU/logo.webp",
    description:
      "My biggest personal project yet. A friendly dashboard that helps non-technical friends follow an Archipelago multi-world session: live progress tracking ,hint-lookup and death tracking. All that self-hostable or available through the server I made available to public.",
    highlights: [
      "Pulls hint data straight out of the running AP session, parsing had to be reverse-engineered",
      "UI rebuilt for beginners (no jargon, no console, no client launch)",
      "TypeScript front + FastAPI back, no database so easy to deploy",
        "The hosted version uses a Caddy supervisor to handle sleeping/dead rooms and save memory"
    ],
    liveSrc: "https://ap-dashboard.online/",
    externalHref: "https://github.com/NhkI0/archipelago-web-dashboard"
  },
  {
    title: "Fitgirl Repacks Scraper",
    version: "main",
    image: "https://camo.githubusercontent.com/b880cbfa2c25ca5eea07548b299ea72f5cd69522fe090789abf59b1a64f96f37/68747470733a2f2f69312e736e6463646e2e636f6d2f617274776f726b732d6438494547704a7456446a6c513736622d7766425546412d74353030783530302e6a7067",
    description:
      "CLI tool that downloads games from FitGirl Repacks via the FuckingFast host: resolves links, supports resume, and runs 7zip extraction once the parts arrive.",
    highlights: [
      "Handle everything from getting links to unzipping the game",
      "Bypass network restrictions :p",
      "Headless Chrome (Selenium + chromedriver) defeats the JS-only download gate",
      "Resumable parts via HTTP Range + per-part offset checkpoints",
    ],
    externalHref: "https://github.com/NhkI0/Fitgirl-FuckingFast-Scraper"
  },
  {
    title: "Discord Livechat",
    version: "main",
    image: "https://preview.redd.it/discord-app-icon-for-ios-6-v0-5s9l4e0722n71.png?width=385&format=png&auto=webp&s=256fb68af0a9864ce2fa0570ee1bdb7ff3a34a38",
    description:
      "A small client/server experiment that bridges a Discord channel to a web front-end in (near) real time. " +
      "Mostly an excuse to play with Discord's gateway and websockets but " +
      "also to send loud videos while my friends play rankeds.",
    highlights: [
      "discord.js Gateway intents (MessageCreate / Typing) piped to clients",
      "Server fans out to browsers over a single multiplexed WebSocket",
      "Bot token stays server-side; clients only get a short-lived session JWT",
    ],
    externalHref: "https://github.com/NhkI0/discord-livechat"
  },
  {
    title: "Portfolio Optimizer",
    version: "main",
    image: "https://blob.gifcities.org/gifcities/OTNFO2V6NZ7PC6VTXRQ7QOZJNHX7W3OX.gif",
    description:
      "<b>[School Project]</b> Multi-objective portfolio optimization: weighted-sum, epsilon-constraint and an NSGA-II evolutionary search produce Pareto fronts (return / risk / cost), browsable in a Streamlit UI.",
    highlights: [
      "Allow getting optimized diverse stocks portfolios",
      "Let the user go for a safe or a rewarding combinaison",
      "Made \"noob\" friendly thanks to the Streamlit app",
    ],
    externalHref: "https://github.com/NhkI0/multi-criteria-optimization"
  },
  {
    title: "SpotifyDock",
    version: "v1.1.1",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Spotify_logo_2008%E2%80%932012.svg/250px-Spotify_logo_2008%E2%80%932012.svg.png",
    description:
      "A compact Windows taskbar player for Spotify: shows album art, track info and playback controls with live progress, in three docking modes, without needing the main Spotify window open.",
    highlights: [
      "Win32 AppBar API via P/Invoke for true taskbar docking",
      "SpotifyAPI-NET PKCE OAuth + 1Hz playback-state poll",
      "MVVM bindings via CommunityToolkit.Mvvm source generators"
    ],
    externalHref: "https://github.com/NhkI0/SpotifyDock"
  },
  {
    title: "AI Trading Agent",
    version: "main",
    image: "https://blob.gifcities.org/gifcities/ILGQK2IHYS7RWJST4LMUF26OEOUJ2LPF.gif",
    description:
      "A crypto trading pipeline (data → features → model → backtest / paper-trade) that trains eight model families on a shared feature dataset: CNN, LSTM, BiLSTM, Transformer, PatchTST, XGBoost, a PPO RL agent, and an ensemble.",
    highlights: [
      "8 PyTorch heads (CNN / LSTM / BiLSTM / Transformer / PatchTST / XGBoost / PPO / ensemble) on one shared feature parquet",
      "PPO agent in a custom Gymnasium env wrapping historical OHLCV klines",
      "Backtest and paper-trade share the same ccxt connector & risk layer"
    ],
    externalHref: "https://github.com/Nexgear75/ai_trading_agent"
  },
    {
    title: "Guess The Splash",
    version: "v0.1.0",
    image: "https://wiki.leagueoflegends.com/en-us/images/League_of_Legends_icon_old2.png?75083",
    description:
      "A League of Legends mini-game inspired by Loldle: a champion splash art is partially blurred or cropped, and you have to guess which champion it is.",
    highlights: [
      "Auto-pulls each new Riot patch from DDragon (champions, splashes, skins)",
      "Random-crop pipeline on a Canvas 2D filter",
      "Champion roster and assets cached via Next.js ISR so a patch ships without a redeploy",
    ],
    liveSrc: "https://nguengant.fr/gts",
    externalHref: "https://github.com/NhkI0/lol-guess-splash"
  },
  {
    title: "D4G - Green AI",
    version: "v0.9",
    image: "https://blob.gifcities.org/gifcities/TMXCY6LXZOM5I234EFPO4QZXURGKDECL.gif",
    description:
      "Inter-school team project: take a deliberately wasteful baseline model and summarize a text in 10-15 words while consuming as little energy as possible. The live demo is offline (the model ate too much VPS memory) and the source isn't public yet.",
    highlights: [
      "Bench scored on ROUGE per watt-hour via codecarbon",
      "Distillation + 8-bit quantization to fit a 1 GB VPS slice",
      "Inter-school team project; taught me how loud one transformer can be"
    ],
    externalHref: "https://github.com/NhkI0",
    disabled: true
  }
];

const escapeAttr = s => String(s).replace(/'/g, "\\'").replace(/"/g, "&quot;");

const renderActions = p => {
  const parts = [];
  if (p.disabled) {
    parts.push(
      `<span class="btn btn-disabled" aria-disabled="true">&#9654; UNAVAILABLE</span>`
    );
    return parts.join("");
  }
  if (p.liveSrc) {
    parts.push(
      `<button class="btn btn-run" onclick="window.__pbOpenIframe && window.__pbOpenIframe('${escapeAttr(
        p.liveSrc
      )}','${escapeAttr(p.title)}')">&#9654; RUN</button>`
    );
  }
  if (p.externalHref) {
    parts.push(
      `<a class="btn btn-src" href="${p.externalHref}" target="_blank" rel="noopener noreferrer">&#9654; SOURCE</a>`
    );
  }
  return parts.join("");
};

const renderCard = p => `
  <div class="card${p.disabled ? " card-disabled" : ""}">
    <div class="card-title">
      <div class="card-title-stripe"></div>
      <div class="card-title-row">
        <span class="card-title-text">${p.title}</span>
        <span class="card-ver">${p.version || ""}</span>
      </div>
    </div>
    <div class="card-body">
      <div class="card-shot-wrap">
        <img class="card-shot" src="${p.image}" alt="${escapeAttr(p.title)} screenshot" />
      </div>
      <div class="card-meta">
        <div class="card-desc">${p.description}</div>
        <div class="card-reqs">
          <div class="card-reqs-h">FEATURES:</div>
          <ul>${(p.highlights || p.tech || []).map(t => `<li>${t}</li>`).join("")}</ul>
        </div>
        <div class="card-actions">${renderActions(p)}</div>
      </div>
    </div>
  </div>
`;

const neonStyle = `
<style>
  @keyframes pb-rainbow-slide {
    0%   { background-position:   0% 50%; }
    100% { background-position: 300% 50%; }
  }
  @keyframes pb-blink {
    0%, 49% { opacity: 1; }
    50%, 100% { opacity: 0; }
  }
  .pb-projects-neon {
    font-family: 'Courier New', 'Comic Sans MS', monospace;
    font-size: 14px;
    line-height: 1.55;
    color: #ffffff;
    background: #000;
    background-image: radial-gradient(ellipse at top, #160029 0%, #000 70%);
    padding: 14px;
    min-height: 100%;
    box-sizing: border-box;
  }
  .pb-projects-neon * { box-sizing: border-box; }
  .pb-projects-neon a { color: #d4ff4d; }

  /* ---- Hero ---- */
  .neon-hero {
    text-align: center;
    margin-bottom: 16px;
    padding: 14px 6px 10px;
    background: #0d0020;
    border: 2px solid #ff5cf2;
    box-shadow: 0 0 12px rgba(255, 92, 242, 0.45);
  }
  .neon-hero h1 {
    margin: 0;
    font-family: 'Impact', 'Arial Black', sans-serif;
    font-size: 40px;
    letter-spacing: 3px;
    color: #ffffff;
    text-shadow:
      0 0 6px #ff5cf2,
      0 0 14px #ff5cf2,
      2px 2px 0 #000;
  }
  .neon-tagline {
    color: #5cf6ff;
    font-weight: bold;
    margin-top: 8px;
    text-shadow: 0 0 4px rgba(92, 246, 255, 0.6);
    font-size: 13px;
  }

  /* ---- Grid ---- */
  .neon-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 16px;
  }

  /* ---- Card ---- */
  .pb-projects-neon .card {
    background: #100022;
    border: 2px solid #ff5cf2;
    box-shadow:
      0 0 10px rgba(255, 92, 242, 0.45),
      inset 0 0 0 1px #2a004d;
  }
  .pb-projects-neon .card-disabled { opacity: 0.6; filter: grayscale(0.4); }

  .pb-projects-neon .card-title {
    background: #1a0033;
    border-bottom: 1px solid #ff5cf2;
  }
  .pb-projects-neon .card-title-stripe {
    height: 4px;
    background: linear-gradient(90deg, #ff5cf2, #5cf6ff, #d4ff4d, #ff5cf2);
    background-size: 300% 100%;
    animation: pb-rainbow-slide 24s linear infinite;
  }
  .pb-projects-neon .card-title-row {
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #ffffff;
    font-weight: bold;
    letter-spacing: 1px;
    font-size: 15px;
  }
  .pb-projects-neon .card-ver {
    background: #000;
    color: #d4ff4d;
    padding: 2px 8px;
    border: 1px solid #d4ff4d;
    font-size: 11px;
    letter-spacing: 1px;
    font-weight: normal;
  }

  .pb-projects-neon .card-body {
    padding: 12px;
    display: grid;
    grid-template-columns: 130px 1fr;
    gap: 12px;
  }
  .pb-projects-neon .card-shot-wrap {
    background: #000;
    border: 2px solid #5cf6ff;
    box-shadow: 0 0 6px rgba(92, 246, 255, 0.55);
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .pb-projects-neon .card-shot { max-width: 100%; max-height: 100%; }

  .pb-projects-neon .card-meta { display: flex; flex-direction: column; gap: 10px; min-width: 0; }
  .pb-projects-neon .card-desc { color: #f5f0ff; }

  .pb-projects-neon .card-reqs-h {
    color: #ff8df5;
    font-weight: bold;
    letter-spacing: 1px;
    margin-bottom: 2px;
  }
  .pb-projects-neon .card-reqs ul {
    margin: 0;
    padding: 0;
    list-style: none;
    color: #d4ff4d;
  }
  .pb-projects-neon .card-reqs li { padding: 1px 0; }
  .pb-projects-neon .card-reqs li::before { content: ">> "; color: #5cf6ff; }
  .pb-projects-neon .card-reqs li:last-child::after {
    content: " _";
    color: #d4ff4d;
    animation: pb-blink 1.2s steps(2) infinite;
  }

  .pb-projects-neon .card-actions { display: flex; gap: 10px; margin-top: 4px; flex-wrap: wrap; }
  .pb-projects-neon .btn {
    font-family: 'Courier New', monospace;
    font-weight: bold;
    font-size: 13px;
    padding: 7px 16px;
    background: #000;
    color: #d4ff4d;
    border: 2px solid #ff5cf2;
    box-shadow: 0 0 6px rgba(255, 92, 242, 0.6);
    text-decoration: none;
    cursor: pointer;
    letter-spacing: 1px;
    display: inline-block;
    transition: background 0.12s linear, color 0.12s linear, box-shadow 0.12s linear;
  }
  .pb-projects-neon .btn-run {
    color: #5cf6ff;
    border-color: #5cf6ff;
    box-shadow: 0 0 6px rgba(92, 246, 255, 0.6);
  }
  .pb-projects-neon .btn:hover {
    background: #ff5cf2;
    color: #000;
    box-shadow: 0 0 14px #ff5cf2;
  }
  .pb-projects-neon .btn-run:hover {
    background: #5cf6ff;
    color: #000;
    box-shadow: 0 0 14px #5cf6ff;
  }
  .pb-projects-neon .btn-disabled {
    color: #6a6a78;
    border-color: #6a6a78;
    box-shadow: none;
    background: #0a0014;
    cursor: not-allowed;
    pointer-events: none;
    text-decoration: line-through;
    opacity: 0.7;
  }

  /* ---- Footer ---- */
  .neon-footer {
    margin-top: 16px;
    padding: 10px;
    text-align: center;
    background: #0d0020;
    border: 2px solid #5cf6ff;
    color: #5cf6ff;
    font-size: 13px;
  }
  .neon-counter {
    display: inline-block;
    font-family: 'Courier New', monospace;
    background: #000;
    color: #d4ff4d;
    padding: 2px 10px;
    border: 1px solid #d4ff4d;
    letter-spacing: 4px;
    margin: 0 6px;
  }
</style>
`;

const neonPage = `
${neonStyle}
<div class="pb-projects-neon">
  <div class="neon-hero">
    <h1>&#10022; NOÉ'S PROJECTS &#10022;</h1>
    <div class="neon-tagline">
      <marquee scrollamount="3">~*~ click RUN to launch in-desktop, SOURCE for the code ~*~ thanks for visiting ~*~</marquee>
    </div>
  </div>

  <div class="neon-grid">
    ${projects.map(renderCard).join("")}
  </div>

  <div class="neon-footer">
    visitors: <span class="neon-counter">0000042</span>
    &middot; <a href="https://github.com/NhkI0" target="_blank" rel="noopener noreferrer">github.com/NhkI0</a>
    &middot; <i>Best viewed in Netscape Navigator 4</i>
  </div>
</div>
`;

export default neonPage;
